import loggerStateFilter from 'app/filters/loggerState'

export default class LoggerState {

    static AVAILABLE = 'AVAILABLE';
    static DEPLOYED = 'DEPLOYED';
    static RETURNING = 'RETURNING';
    static REPAIR_PENDING = 'REPAIR_PENDING';
    static REPAIR_ACTIVE = 'REPAIR_ACTIVE';
    static WRITTEN_OF = 'WRITTEN_OF';

    static options(){

        return {
            'AVAILABLE': loggerStateFilter(LoggerState.AVAILABLE),
            'DEPLOYED': loggerStateFilter(LoggerState.DEPLOYED),
            'RETURNING': loggerStateFilter(LoggerState.RETURNING),
            'REPAIR_PENDING': loggerStateFilter(LoggerState.REPAIR_PENDING),
            'REPAIR_ACTIVE': loggerStateFilter(LoggerState.REPAIR_ACTIVE),
            'WRITTEN_OF': loggerStateFilter(LoggerState.WRITTEN_OF),
        };
    }
}